import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWhatsApp = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29246_1383)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M0.84123 7.90428C0.840855 9.24859 1.19486 10.5612 1.86798 11.7182L0.776855 15.6712L4.85386 14.6104C5.9815 15.2196 7.24494 15.5387 8.52886 15.5388H8.53223C12.7707 15.5388 16.2209 12.1166 16.2227 7.91029C16.2235 5.87203 15.4242 3.95538 13.9721 2.51339C12.5202 1.07153 10.5893 0.277053 8.53192 0.276123C4.29298 0.276123 0.843043 3.69814 0.841293 7.90428",
			fill: "url(#paint0_linear_29246_1383)"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M6.54223 4.59831C6.3931 4.26944 6.23616 4.2628 6.09435 4.25704C5.97823 4.25208 5.84548 4.25245 5.71285 4.25245C5.5801 4.25245 5.36441 4.302 5.1821 4.49952C4.9996 4.69722 4.48535 5.17499 4.48535 6.14671C4.48535 7.11849 5.19866 8.0576 5.2981 8.1895C5.39766 8.32116 6.67516 10.3791 8.69841 11.1708C10.3799 11.8287 10.7221 11.6978 11.087 11.6649C11.452 11.632 12.2648 11.1872 12.4306 10.726C12.5965 10.2649 12.5965 9.86956 12.5468 9.78696C12.497 9.70467 12.3643 9.65524 12.1652 9.55651C11.9661 9.45772 10.9875 8.97989 10.805 8.91397C10.6225 8.84811 10.4899 8.81524 10.3571 9.01301C10.2244 9.21046 9.84316 9.65524 9.72698 9.78696C9.61091 9.91899 9.49473 9.93542 9.29573 9.83663C9.09654 9.73753 8.45548 9.52922 7.69491 8.85642C7.10316 8.33288 6.70366 7.68637 6.58754 7.4886C6.47141 7.29115 6.5751 7.18411 6.67491 7.08569C6.76435 6.99719 6.87404 6.85505 6.97366 6.73977C7.07291 6.62442 7.10604 6.54212 7.17241 6.4104C7.23885 6.27856 7.2056 6.16321 7.15591 6.06442C7.10604 5.96563 6.71923 4.98882 6.54223 4.59831Z",
			fill: "white"
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_29246_1383",
		x1: 773.068,
		y1: 1539.78,
		x2: 773.068,
		y2: .276123,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#1FAF38" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#60D669"
		})]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29246_1383",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white",
			transform: "translate(0.5)"
		})
	})] })]
});
export default SvgWhatsApp;
